import React from 'react'
import styled from 'styled-components'

import ModalFooterActionContainer from '../TripModal/TripItems/Create/ModalFooterActionContainer'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import { ItemMetadata } from 'tripPlanner/models'
import { TripItem } from 'tripPlanner/types/tripItem'
import { rem } from 'polished'

const StyledModalContent = styled(ModalContent)`
  margin-bottom: ${rem(32)};
`

interface Props {
  item: TripItem
  updateTripDates: () => void
  currentTripDates: string
  extendedTripDates: string
  isLoading: boolean
}

function BookedItemExtendDatesModal(props: Props) {
  const {
    item,
    updateTripDates,
    currentTripDates,
    extendedTripDates,
    isLoading,
  } = props

  const { closeModal } = useModalCallbacks()

  const isMobile = useScreenSizeOnly('mobile')
  return (
    <>
      <ModalHeader
        title={`Your booked ${ItemMetadata[
          item.type
        ].singularName.toLowerCase()} falls outside your trip dates`}
        onCloseButtonClick={closeModal}
      />
      <ModalBody>
        <StyledModalContent>
          <VerticalSpacer gap={12}>
            <BodyTextBlock variant="large">
              Would you like to extend trip duration to include your booking?
            </BodyTextBlock>
            <br />
            <div>
              <BodyTextBlock variant="large">
                <b>Current trip dates: </b> {currentTripDates}
              </BodyTextBlock>
              <BodyTextBlock variant="large">
                <b>New trip dates:</b> {extendedTripDates}
              </BodyTextBlock>
            </div>
          </VerticalSpacer>
        </StyledModalContent>
      </ModalBody>
      <ModalFooter>
        <ModalFooterActionContainer>
          <TextButton
            kind="secondary"
            size="large"
            fit={`${isMobile ? 'full-width' : 'auto'}`}
            onClick={closeModal}
          >
            Not for now
          </TextButton>
          <TextButton
            kind="primary"
            size="large"
            fit={`${isMobile ? 'full-width' : 'auto'}`}
            onClick={updateTripDates}
            disabled={isLoading}
          >
            Confirm new trip dates
          </TextButton>
        </ModalFooterActionContainer>
      </ModalFooter>
    </>
  )
}

export default BookedItemExtendDatesModal
